<template>
  <div class="mb-4">
    <span class="caption grey--text text--darken-1"> {{ label }}</span>
    <div
      v-if="!diagnosis || !diagnosis.id"
      class="px-3 card-rounded border grey--border"
    >
      <DiagnoseInput
        :diagnosis.sync="diagnosis"
        itemValue="code"
        itemText="diagnosis"
        :showFavorites="showFavorites"
      />
    </div>
    <v-list two-line v-else class="px-3 border-bottom grey--border">
      <v-list-tile>
        <v-list-tile-content>
          <v-list-tile-title v-html="diagnosis.diagnosis"></v-list-tile-title>
          <v-list-tile-sub-title
            >{{ diagnosis.group }} -
            {{ diagnosis.category }}</v-list-tile-sub-title
          >
        </v-list-tile-content>
        <v-list-tile-action>
          <v-btn icon @click="removeItem">
            <v-icon>delete</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import DiagnoseInput from '../../../components/inputs/DiagnoseInput.vue'

export default {
  props: {
    value: { type: Object },
    label: { type: String },
    mainIcd10: { type: Boolean, default: false }
  },
  components: {
    DiagnoseInput
  },
  data() {
    return {
      showFavorites: false,
      loading: false,
      item: null,
      selection: null,
      items: [],
      search: null,
      selectedItems: [],
      paneIndex: null,
      showEditorPane: false,
      diagnosis: {}
    }
  },
  computed: {
    ...mapGetters(['user'])
  },
  watch: {
    diagnosis(val) {
      if (val && val.id) {
        const diagnosisKeys = Object.keys(val)
        diagnosisKeys.forEach(key => {
          if (val[key] === '') {
            delete val[key]
          }
        })
        delete val['_highlightResult']
        delete val['objectID']
        delete val['aliases']
        delete val['aliases_en']
        this.emitUpdate(val)
      }
    }
  },
  created() {
    if (this.value) {
      this.diagnosis = this.value
    }
  },

  methods: {
    emitUpdate(newItems) {
      this.$emit('input', newItems)
    },
    removeItem() {
      this.$emit('input', {})
      this.diagnosis = {}
    }
  }
}
</script>

<style>
div.icd-autocomplete a {
  height: 100%;
}
.border-bottom {
  border-bottom: 1px solid #ccc;
}
</style>
